const isObject = (value) => typeof value === 'object' && !!value && !Array.isArray(value);

export default isObject;
